import { InputLabel, Select } from '@mui/material';
import React from 'react';
import { StyledFormControl } from './styles';

import { ISelectFilter } from './type';
import Box from 'v2/components/UI/Box';

//TODO: REFACTOR IN FUTURE
const SelectFilter: React.FC<ISelectFilter> = ({
  children,
  onChange,
  value,
  label,
  labelId,
  selectId,
  width,
  maxWidth,
  ...rest
}) => {
  return (
    <Box width={width} maxWidth={maxWidth} borderRadius={16}>
      <StyledFormControl fullWidth size="small">
        <InputLabel sx={{ marginTop: '-2px' }} id={labelId}>
          {label}
        </InputLabel>
        <Select
          sx={{
            fontSize: 12,
            borderRadius: '16px',
            padding: '2px 4px',
          }}
          labelId={labelId}
          id={selectId}
          value={value}
          label={label}
          onChange={onChange}
          {...rest}
        >
          {children}
        </Select>
      </StyledFormControl>
    </Box>
  );
};

export default SelectFilter;
